/* globals functionality, login, rulesFlow, views, showModalError, showModalConfirm */
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Request from "common/Request";
import BqnContext from "common/BqnContext";
import {
  convertPolicyFlowStatisticsResponse,
  ShowPolicies,
} from "views/Status/Policies/Flow/component";
import { getPoliciesInRules } from "common/api";

const returnView = "viewRulesFlow";

export const SubscriberFlowPoliciesTable = () => {
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const [request, setRequest] = useState(null);

  const doRequest = (mode, bqnId) => {
    const cliBqnSpec =
      mode === "standalone" || bqnId === "all" ? "" : ` bqn-id ${bqnId}`;
    return ifCl
      .run(
        `${[
          `show policy flow statistics web${cliBqnSpec}`,
          "show config running all",
        ].join("\n")}\n`,
        /*is batch*/ true,
      )
      .then((response) => {
        const [policiesResponse, configResponse] = response.split(",");
        const policies = convertPolicyFlowStatisticsResponse(policiesResponse);
        const rules = getPoliciesInRules(configResponse, "flow");
        return {policies, rules}
      })
      .catch((error) => console.log(error));
  };

  const doLoad = (mode, bqnId) => {
    setRequest(doRequest(mode, bqnId));
  };

  useEffect(() => {
    doLoad(mode, bqnId);
  }, [mode, bqnId]);

  return request === null ? null : (
    <div className="row clearfix">
      <div className="body table-responsive">
        <Request during={request}>
          {({ policies, rules }) => (
            <ShowPolicies
              policies={policies}
              rules={rules}
              reload={() => doLoad(mode, bqnId)}
              returnView={returnView}
            />
          )}
        </Request>
      </div>
    </div>
  );
};
